import React from 'react';
import { type Column, type RowData } from '@tanstack/react-table';

import { DataTableColumnHeader } from 'src/component/ds/ui/dataTableColumnHeader';
import { type DataTableFeatures } from 'src/component/ds/ui/dataTableFeatures';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/component/ds/ui/tooltip';

interface IconColumnHeaderProps<TData extends RowData, TValue> {
  column: Column<DataTableFeatures, TData, TValue>
  /** Tooltip and accessible name for the icon. */
  title: string
  icon: React.ReactNode
}

/* Icon-only DataTableColumnHeader. */
export function IconColumnHeader<TData extends RowData, TValue> ({ column, title, icon }: IconColumnHeaderProps<TData, TValue>) {
  return (
    <TooltipProvider delayDuration={200}>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className='ds-w-fit'>
            <DataTableColumnHeader
              column={column}
              title={(
                <>
                  <span aria-hidden='true' className='[&_svg]:ds-size-4'>{icon}</span>
                  <span className='ds-sr-only'>{title}</span>
                </>
              )}
            />
          </div>
        </TooltipTrigger>
        <TooltipContent>{title}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
